import { useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "./ui/alert-dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { X, Loader2 } from "lucide-react";

export function CancelBookingButton({ onConfirm, testid, label = "Cancelar cita", description }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");

  const confirm = async () => {
    setLoading(true);
    try { await onConfirm(reason.trim()); setOpen(false); setReason(""); }
    finally { setLoading(false); }
  };

  return (
    <AlertDialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setReason(""); }}>
      <AlertDialogTrigger asChild>
        <Button size="sm" variant="outline" className="rounded-xl border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700 font-bold shrink-0" data-testid={testid}>
          <X className="h-4 w-4 mr-1" />{label}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid={`${testid}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Estás seguro de cancelar la cita?</AlertDialogTitle>
          <AlertDialogDescription>
            {description || "Esta acción no se puede deshacer. Se liberará la franja horaria y la cita quedará cancelada."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-1.5">
          <Label htmlFor={`${testid}-reason`} className="text-sm font-semibold text-[#373E45]">Motivo de la cancelación (opcional)</Label>
          <Textarea id={`${testid}-reason`} value={reason} onChange={(e) => setReason(e.target.value)}
            placeholder="Ej.: la clínica ha pedido cambio de fecha, el paciente ya no lo necesita…"
            className="rounded-xl resize-none" rows={3} data-testid={`${testid}-reason-input`} />
          <p className="text-xs text-[#94A3B8]">Se incluirá en el aviso por email a la otra parte.</p>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-no`}>No, volver</AlertDialogCancel>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); confirm(); }} disabled={loading} className="bg-red-600 hover:bg-red-700 text-white" data-testid={`${testid}-yes`}>
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sí, cancelar cita"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
